export interface TokenType {
  token: string;
  platform: 'web' | 'ios' | 'android';
}

type DirectMessage = {
  type: 'DirectMessage';
  text: string;
};

type ClassPreparationMessage = {
  type: 'ClassPreparation';
  teacherUserName: string;
  studentUsername: string;
  // ISO 8601 hh:mmZ
  time: string;
};

// export type NotificationMessage = DirectMessage | ClassPreparationMessage;
export type NotificationMessage = {
  channelId: string;
  messageId: string;
  messageContent: string;
  senderName: string;
  channelName: string;
  action?: 'retract';
} & {
  type?: 'navigate';
};
export type onMessageHandler = (message: NotificationMessage) => void;
export type onClickNotificationHandler = (message: NotificationMessage) => void;

interface Unsubscribe {
  (): void;
}

export abstract class NotificationBase {
  abstract requestPermission(): Promise<NotificationPermission | `${NotificationPermission}`>;
  abstract getPermissionState(): Promise<NotificationPermission | `${NotificationPermission}`>;
  abstract requestToken(): Promise<TokenType | null>;
  abstract onMessage(handler: onMessageHandler): Promise<Unsubscribe>;
  abstract setBadgeCount(count: number): void;
  abstract onNotificationClick(handler: onClickNotificationHandler): Unsubscribe;
  // Added: iOS/Native 브릿지 및 플랫폼별 알림 정리를 위한 공통 시그니처
  abstract clearNotificationsByChannel(channelId: string): Promise<void>;
  abstract clearAllNotifications(): Promise<void>;
  // Added: 구현체가 알림 기능을 지원하는지 여부
  abstract supportsNotifications(): boolean;
  // Added: 유저가 현재 열어서 보고 있는 채팅 채널을 네이티브에 알린다.
  // 네이티브(Android)는 이 정보를 사용해 FCM 수신 시 해당 채널 메시지의
  // 시스템 알림을 억제한다. null 이면 "채널을 보고 있지 않음".
  // iOS/Web 등 다른 구현체는 현재 no-op.
  abstract setActiveChannel(channelId: string | null): void;
}

export default NotificationBase;
